import React from "react";
import Navbar from "./Navbar";

const Layout = ({ children }) => {
  return (
    <div className="text-[#111827]">
      <Navbar />
      {children}
    </div>
  );
};

export default Layout;
